
import React from 'react';
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { RotateCcw, Check, X, Square } from "lucide-react";

interface CropperDialogProps {
  isOpen: boolean;
  onClose: () => void;
  processing: boolean;
  completedCrop: any;
  onReset: () => void;
  onSave: () => void;
  children: React.ReactNode;
}

const CropperDialog = ({
  isOpen,
  onClose,
  processing,
  completedCrop,
  onReset,
  onSave,
  children
}: CropperDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Square className="w-5 h-5 text-pink-500" />
            Create Square Profile Photo
          </DialogTitle>
          <p className="text-sm text-gray-600 mt-1">
            Drag to position your photo within the square frame. Pinch to zoom in/out. The aspect ratio is locked to create a perfect square.
          </p>
        </DialogHeader>
        
        <div className="space-y-4">
          {children}
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onReset}
            disabled={processing}
            className="flex items-center gap-2"
          >
            <RotateCcw className="w-4 h-4" />
            Reset
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            disabled={processing}
            className="flex items-center gap-2"
          >
            <X className="w-4 h-4" />
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={processing || !completedCrop}
            className="flex items-center gap-2 bg-pink-500 hover:bg-pink-600"
          >
            <Check className="w-4 h-4" />
            {processing ? 'Creating Square Photo...' : 'Save Square Photo'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CropperDialog;
